import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import OrderTable from "../components/orders/OrderTable";
import baseUrl from "../url/baseUrl";

// component hiển thị lịch sử order
const OrderHistory = () => {
  const [order, setOrder] = useState([]);
  useEffect(() => {
    const getOrders = async () => {
      try {
        const response = await fetch(baseUrl + "/get-orders", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status === 404) {
          throw new Error("Không có order.");
        }

        if (response.status !== 200) {
          throw new Error("Not yet login or server error.");
        }

        const data = await response.json();

        setOrder(data);
      } catch (err) {
        console.log(err);
      }
    };
    getOrders();
  }, []);

  return (
    <section className="cartPage" style={{ fontSize: "14px" }}>
      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb  ps-3 pt-2 pb-3 mb-0 "
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item">Các đơn hàng của bạn</li>
        </ol>
      </nav>
      <div>
        <h2 className="cart_title ms-3 text-primary">Lịch sử Order</h2>
      </div>
      <div>
        <OrderTable orders={order} />
      </div>
    </section>
  );
};
export default OrderHistory;
